// extracted by mini-css-extract-plugin
export default {"navbarHideable":"navbarHideable_m1mJ","navbarHidden":"navbarHidden_jGov"};